var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("User Manual for"), _c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(" " + _vm._s(_vm.simulatedAccessLevel))])]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Documentation for Enchatment")])]), _c('div', {
    staticClass: "col-sm-4 hidden-sm-down text-right"
  }, [(_vm.userAccessLevel != "agent") ? _c('div', [(_vm.simulatedAccessLevel != "agent") ? _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAccessLevel()
      }
    }
  }, [_vm._v("Agent View")]) : _c('b-btn', {
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleAccessLevel()
      }
    }
  }, [_c('span', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.userAccessLevel))]), _vm._v(" View")])], 1) : _vm._e()])]), _c('br'), _c('p', [_c('b', [_vm._v("Enchatment")]), _vm._v(" is a platform for admins/agents to monitor the company's performance, manage the bot and it contains various features such as "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Dashboard, ")]) : _vm._e(), _vm._v("Interactions, Customers, Broadcast, Training, Chat Flow and CRM.")]), _c('br'), (_vm.simulatedAccessLevel != "agent") ? _c('div', [_c('h3', [_vm._v("Dashboard")]), _c('hr'), _c('p', [_vm._v("The Dashboard feature allows the agents to look at the overall performance of the bot.")]), _c('ol', [_c('li', [_vm._v("At the top section, the agent will be able to see two boxes which records the statistics of "), _c('b', [_vm._v("Total Customers")]), _vm._v(" and "), _c('b', [_vm._v("Total Interactions")]), _vm._v(". It will display the latest updates of the number of customers and the amount of interactions respectively.")]), _c('br'), _c('img', {
    attrs: {
      "src": "static/img/ui/topcustomers.png",
      "alt": "Total Customers"
    }
  }), _c('br'), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/topinteractions.png",
      "alt": "Total Interactions"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("At the middle section, the agent will be able to view "), _c('b', [_vm._v("Top Conversation Topics")]), _vm._v(" which will have the 5 Most Interacted Topics that the customers have used during interaction with the bot. It also displays the Users Count and Interactions Count for the each specific topic. "), _c('br'), _vm._v(" At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/dashboard2.png",
      "alt": "Top Conversation Topics"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("At the bottom section, the agent will be able to monitor "), _c('b', [_vm._v("Real Time Interactions")]), _vm._v(" with the 5 Most Recent Interactions. It displays the updated messages as they are being sent from every customer, including the timestamp that states the time of occurrence of the particular message. "), _c('br'), _vm._v(" At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/dashboard3.png",
      "alt": "Real Time Interactions"
    }
  })]), _c('br')]) : _vm._e(), _c('h3', [_vm._v("Interactions")]), _c('hr'), _c('p', [_vm._v("The Interactions feature is mainly to display the past interactions between the customers and the bot. It has a list of interactions which will be running in real-time for agents to know what is happening so that they are able to control the bot. There are two types of interactions: "), _c('b', [_vm._v("Flagged")]), _vm._v(" and "), _c('b', [_vm._v("Unflagged")]), _vm._v(".")]), _c('p', [_vm._v("In every interaction, the replies that are being sent back to the customer will be from 2 different parties: "), _c('b', [_vm._v("Bot")]), _vm._v(" and "), _c('b', [_vm._v("Live Agent")]), _vm._v(". Each types of the replies will be differentiated in colour variations:")]), _c('ol', [_c('li', [_vm._v("Replies from "), _c('b', [_vm._v("Bot")]), _vm._v(" will be "), _c('i', [_vm._v("blue")]), _vm._v(" in colour.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/msg1.png",
      "alt": "Bot Message"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Replies from "), _c('b', [_vm._v("Live Agent")]), _vm._v(" will be "), _c('i', [_vm._v("green")]), _vm._v(" in colour.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/msg2.png",
      "alt": "Live Agent Message"
    }
  })]), _c('br'), _c('h5', [_vm._v("Unflagged")]), _c('p', [_vm._v("For the unflagged interactions, there are 3 different action buttons that the agents can perform towards every specific interaction: "), _c('b', [_vm._v("Quicksend")]), _vm._v(", "), _c('b', [_vm._v("History")]), _vm._v(" and "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(".")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/actions.png",
      "alt": "Action Buttons"
    }
  }), _c('br'), _c('br'), _c('ol', [_c('li', [_vm._v("Click on "), _c('b', [_vm._v("Quicksend")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to send messages instantly.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/quicksend.png",
      "alt": "Quicksend"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Click on "), _c('b', [_vm._v("History")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to view the history of the interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/history.png",
      "alt": "History"
    }
  }), _c('br'), _c('br'), _c('li', [_vm._v("Click on "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to takeover the bot by pausing autoreply.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/pause.png",
      "alt": "Pause Autoreply"
    }
  })]), _c('br'), _c('p', [_vm._v("When a bot is paused, the whole chat box will be covered in a "), _c('b', [_vm._v("red")]), _vm._v(" border and it will be stated as "), _c('b', [_vm._v("Agent Takeover Active")]), _vm._v(". However, the agent will be "), _c('b', [_vm._v("disconnected")]), _vm._v(" from the chat after 30 seconds of idle, but the 30 seconds timer will reset whenever the live agent is still replying to the customer.")]), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/takeover.png",
      "alt": "Takeover"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("Whenever two agents are accessing the same interaction, the latter will receive a screen covered in red. This is because only one agent is able to access and takeover an interaction.")]), _c('br'), _c('h5', [_vm._v("Flagged")]), _c('p', [_vm._v("When the interactions in this section are highlighted in red colour, these are the interactions that are in need of attention for an agent to takeover. After 90 seconds, the flagged interactions will be changed back to unflagged if nothing happens to it (no takeover by agents). After pausing the bot, the input field is a "), _c('b', [_vm._v("quicksend")]), _vm._v(" function that can be used to instantly reply customers without pressing into the chat or button as it is faster to reply a flagged interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/flagged.png",
      "alt": "Flagged"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('img', {
    attrs: {
      "src": "/static/img/ui/export.png",
      "alt": "Export"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("Click on "), _c('b', [_vm._v("Pause Autoreply")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be able to pause and resume "), _c('b', [_vm._v("ALL")]), _vm._v(" autoreplies of the bot for every single interaction.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/pauseautoreply.png",
      "alt": "Pause All"
    }
  }), _c('br'), _c('br'), _c('img', {
    attrs: {
      "src": "/static/img/ui/resume.png",
      "alt": "Resume All"
    }
  }), _c('br'), _c('br'), _c('h3', [_vm._v("Complaints")]), _c('hr'), _c('p', [_vm._v("This is where all complaints are being sent that will notify the agent and it will display the names, messages of the complaint, ID, timestamps etc. The agent will be able to send an "), _c('b', [_vm._v("email")]), _vm._v(" to the user of the particular complaint to reply to their negative feedback.")]), _c('p', [_vm._v("Click on "), _c('b', [_vm._v("Email")]), _vm._v(". "), _c('br'), _vm._v(" The agent will be redirected to a link to send out the email.")]), _c('img', {
    attrs: {
      "src": "/static/img/ui/email.png",
      "alt": "Email"
    }
  }), _c('br'), _c('br'), _c('p', [_vm._v("At the top right of the table, an "), _c('b', [_vm._v("Export")]), _vm._v(" button will be available. "), (_vm.simulatedAccessLevel != "agent") ? _c('span', [_vm._v("Supervisor will be able to download as Excel Spreadsheet while agent will be able to download as PDF.")]) : _c('span', [_vm._v("Agent will be able to download as PDF.")])]), _c('img', {
    attrs: {
      "src": "/static/img/ui/export.png",
      "alt": "Export"
    }
  })])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3f4c9e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Manual.vue
// module id = 931
// module chunks = 1